export const REGISTER_HEADER_STRINGS = {
  platformName: 'Licensing Management Platform',
} as const
